
import { Control } from "react-hook-form";
import { LocationFormValues } from "./types";
import CountryField from "./CountryField";
import RegionField from "./RegionField";
import CityField from "./CityField";

type LocationFormFieldsProps = {
  control: Control<LocationFormValues>;
};

const LocationFormFields = ({ control }: LocationFormFieldsProps) => {
  if (!control) {
    console.error("Form control is missing in LocationFormFields");
    return null;
  }

  return (
    <div className="space-y-4">
      <CountryField control={control} />
      <RegionField control={control} />
      <CityField control={control} />
    </div>
  );
};

export default LocationFormFields;
